import React, { FC } from 'react';
import { DLP_INSTABOOK_GTAG_EVENT } from 'src/common/constants';
import DlpLayout from 'src/search/components/DlpLayout';
import type { DlpListingsProps } from 'src/search/components/DlpListings';
import DlpListings from 'src/search/components/DlpListings';
import Icon from 'src/common/components/IconDS22';
import styles from './DlpListingsInstabook.module.scss';

/**
 * A simple wrapper around DlpListings to keep DlpLayout out of DlpRoot
 * Following the pattern of other components.
 */
const DlpListingsInstabook: FC<DlpListingsProps> = ({
  listings,
  title,
  subTitle,
  categorySlug,
  locationSlug,
  ...dataAttributes
}) => (
  <DlpLayout>
    <div className={styles.root}>
      <DlpListings
        title={title}
        subTitle={(
          <p className={styles.subTitle}>
            <Icon id="instabook-filled" className={styles.icon} size="s" />
            {subTitle}
          </p>
        )}
        listings={listings}
        categorySlug={categorySlug}
        locationSlug={locationSlug}
        listingCardVariant="instabook"
        gtagEvent={DLP_INSTABOOK_GTAG_EVENT}
        isInstabookCarousel
        {...dataAttributes}
      />
    </div>
  </DlpLayout>
);

export default DlpListingsInstabook;
